import React from 'react';

export const STATUS_LABELS = {
    lead:            'Lead',
    discovery:       'Discovery',
    proposal_draft:  'Proposal Draft',
    proposal_sent:   'Proposal Sent',
    active:          'Active',
    paused:          'Paused',
    lost:            'Lost',
    archived:        'Archived',
};

export const STATUS_ORDER = [
    'lead', 'discovery', 'proposal_draft', 'proposal_sent', 'active', 'paused', 'lost', 'archived',
];

export default function StatusPill({ status }) {
    const key = status || 'lead';
    const label = STATUS_LABELS[key] || key;
    return (
        <span className={`bm-pill bm-status-${key}`} data-testid={`status-pill-${key}`}>
            <span className="bm-pill-dot" />
            {label}
        </span>
    );
}
